import { SIZING_KIT_DISCOUNT } from '@/app/consts/discounts';
import type { RefreshCartResult } from '@/queries/RefreshCart';

interface PromosFromCart {
  appliedDiscountCode: string;
  promotionCodes: (string | null | undefined)[];
}

const getPromosFromCart = (
  refreshCart: RefreshCartResult | undefined,
): PromosFromCart => {
  const cartPromos = refreshCart?.cart?.refreshCart.cart?.promotions ?? [];
  const promotionCodes = cartPromos.map(
    (promotion) => promotion?.promotionCode,
  );
  const appliedDiscountCode =
    promotionCodes.find((code) => code !== SIZING_KIT_DISCOUNT) ?? '';

  return { appliedDiscountCode, promotionCodes };
};

export default getPromosFromCart;
